import { __decorate } from "tslib";
import { Enum } from '@byted-star/shared-utils';
export class PlatformSource extends Enum.Enum {
}
Object.defineProperty(PlatformSource, "douyin", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 1
});
Object.defineProperty(PlatformSource, "toutiao", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 2
});
Object.defineProperty(PlatformSource, "xigua", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 3
});
Object.defineProperty(PlatformSource, "huoshan", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4
});
Object.defineProperty(PlatformSource, "material", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 5
});
Object.defineProperty(PlatformSource, "nativeMaterial", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 6
});
__decorate([
    Enum.meta({
        media: true,
        name: '抖音',
        authorName: '达人',
    })
], PlatformSource, "douyin", void 0);
__decorate([
    Enum.meta({
        media: true,
        name: '头条',
        authorName: '创作者',
    })
], PlatformSource, "toutiao", void 0);
__decorate([
    Enum.meta({
        media: true,
        name: '西瓜',
        authorName: '创作者',
        oauthKey: 'ixigua',
    })
], PlatformSource, "xigua", void 0);
__decorate([
    Enum.meta({
        media: true,
        name: '火山',
        authorName: '达人',
    })
], PlatformSource, "huoshan", void 0);
__decorate([
    Enum.meta({
        name: '即合素材',
        authorName: '创作者',
    })
], PlatformSource, "material", void 0);
__decorate([
    Enum.meta({
        name: '版权素材',
        authorName: '创作者',
    })
], PlatformSource, "nativeMaterial", void 0);
